import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useState } from "react";

function DeleteEvent({ eventId, onSuccess }) {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        `https://awaretherapycenter.ro/events-back/${eventId}/delete/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.ok) {
        setSuccess("Eveniment șters cu succes!");
        setError("");
        setIsOpen(false);
        onSuccess?.();
      } else {
        const data = await response.json();
        setError(data?.error || "Eroare la ștergere.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Eroare rețea:", err);
      setError("Eroare de rețea.");
    }
  };

  return (
    <div>
      <button
        className="evp-icon-btn danger"
        onClick={() => {
          setIsOpen(true);
          setError("");
          setSuccess("");
        }}
        aria-label="Șterge evenimentul"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="evp-overlay">
        <div className="evp-overlay-bg" aria-hidden="true" />
        <div className="evp-dialog-scroll">
          <Description className="sr-only" />
          <DialogPanel className="evp-dialog-box" style={{ maxWidth: 420 }}>
            <button type="button" className="evp-close-x" onClick={() => setIsOpen(false)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
            <DialogTitle as="h3">Confirmă ștergerea</DialogTitle>
            <p style={{ fontSize: 14, color: "var(--text-l)", lineHeight: 1.7, marginBottom: 8 }}>
              Ești sigur(ă) că vrei să ștergi acest eveniment? Acțiunea nu poate fi anulată.
            </p>
            {error && <p className="evp-msg error">{error}</p>}
            {success && <p className="evp-msg success">{success}</p>}
            <div className="evp-dialog-actions">
              <button className="evp-btn-primary" style={{ background: "#b33", borderColor: "#b33" }} onClick={handleDelete}><span>Șterge</span></button>
              <button className="evp-btn-secondary" onClick={() => setIsOpen(false)}>Anulează</button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </div>
  );
}

export default DeleteEvent;
